export default __webpack_public_path__ + "static/visit-analytics-11b1f3ba5f7a43eacea6f75ecf762a5e.png";